'use client'

import { useNewsDataQuery } from '@/hooks/useContentfulQuery'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import { GA_EVENTS } from '@/utils/analytics'
import { useEffect } from 'react'

const NewsSection = () => {
  const { t } = useTranslation('home')

  const contentType = 'news'

  const { data: news, isPending } = useNewsDataQuery(contentType)

  useEffect(() => {
    if (news?.length) {
      GA_EVENTS.SECTION_VIEW('news_section')
    }
  }, [news])

  if (isPending) return <p>Loading...</p>

  if (!news?.length) return <p>뉴스가 없습니다.</p>

  const handleNewsClick = (newsTitle: string, newsLink: string) => {
    GA_EVENTS.LINK_CLICK(newsTitle, newsLink)
  }

  return (
    <section className="flex flex-col mx-5 sm:mx-auto sm:w-full max-w-[1024px] mb-[110px] sm:mb-[248px]">
      <div className="mb-1">
        <h2 className="font-pretendard-extrabold text-[26px] text-main-light-2 dark:text-main-dark-2 border-b border-gray-400 pb-9">
          {t('news_text_1')}
        </h2>
      </div>
      <div>
        {news.map((news, index) => (
          <Link
            href={news.link}
            key={index}
            className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:items-center border-b py-5"
            onClick={() => handleNewsClick(news.title, news.link)}
          >
            <h3 className="text-lg sm:text-[19px] text-main-light-2 dark:text-main-dark-2 sm:truncate sm:max-w-[80%] leading-tight sm:leading-normal">
              {news.title}
            </h3>
            <p className="text-sm sm:text-[19px] text-main-light-2 dark:text-main-dark-2 font-pretendard-regular">
              {news.issuedDate}
            </p>
          </Link>
        ))}
      </div>
    </section>
  )
}

export default NewsSection
